import { InquiryStatusEnum } from 'anchor-kyb-service/types';
const submittedInquiryStatuses = [
    InquiryStatusEnum.NeedsReview,
    InquiryStatusEnum.Completed
];
export const isSubmittedInquiry = (inquiryStatus)=>submittedInquiryStatuses.includes(inquiryStatus);
